export default function StudentPinPad({ value, onChange, disabled = false }) {
  return <fieldset className="tmag-child-pin" disabled={disabled}>
    <legend>Tu PIN secreto</legend>
    <output aria-label={`${value.length} números ingresados`}>{'●'.repeat(value.length) || '○ ○ ○ ○'}</output>
    <div>{['1','2','3','4','5','6','7','8','9'].map((digit) => <button type="button" key={digit} onClick={() => onChange((value + digit).slice(0, 6))}>{digit}</button>)}
      <button type="button" onClick={() => onChange('')}>Borrar</button>
      <button type="button" onClick={() => onChange((value + '0').slice(0, 6))}>0</button>
      <button type="button" aria-label="Borrar último número" onClick={() => onChange(value.slice(0, -1))}>⌫</button>
    </div>
  </fieldset>;
}

